var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', _vm._l(_vm.templates, function (_ref) {
    var key = _ref[0],
      type = _ref[1],
      serialized = _ref[2];
    return _c('v-col', {
      key: key,
      staticClass: "relative",
      attrs: {
        "cols": "4"
      }
    }, [_c('v-card', {
      attrs: {
        "tile": "",
        "hover": ""
      },
      on: {
        "click": function ($event) {
          return _vm.select(serialized);
        }
      }
    }, [_c('card-preview', {
      attrs: {
        "card": {
          background: _vm.background,
          pages: [JSON.parse(serialized)]
        },
        "mode": "edit"
      }
    })], 1)], 1);
  }), 1);

}
var staticRenderFns = []

export { render, staticRenderFns }